"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalServerError = void 0;
const client_library_1 = require("@seneca/client-library");
class InternalServerError extends client_library_1.ExtendableError {
}
exports.InternalServerError = InternalServerError;
//# sourceMappingURL=InternalServerError.js.map